import { axios } from './vendor.js';

// The container the server renders the panel into, in
// partials/_settings_modal.html.
const PANEL_ID = 'account-status-panel';

/**
 * Keep the account panel inside the settings modal current (ADR-0053 FR-39).
 *
 * The modal is part of every base_app page, so its copy of the panel is built
 * once when the page is and then ages: every figure on the card - answers this
 * month, Opus allowance, uploads, credit - moves with each answer. Refetching
 * on open rather than after an answer keeps this indifferent to *why* a figure
 * changed, and costs a request only when somebody actually looks.
 *
 * A failed refresh leaves the rendered markup alone. Stale numbers are worse
 * than fresh ones and better than an empty card, and the user did not ask for
 * this request in the first place.
 */
export function initAccountStatusRefresh() {
    const modal = document.getElementById('settingsModal');
    const panel = document.getElementById(PANEL_ID);
    if (!modal || !panel) return;

    modal.addEventListener('show.bs.modal', () => {
        axios.get('/api/account-status')
            .then((response) => {
                if (typeof response.data === 'string' && response.data) {
                    panel.innerHTML = response.data;
                }
            })
            .catch(() => {
                // Deliberately silent: the panel on screen is still the truth
                // as of page load, and a toast about a refresh nobody
                // requested would be noise.
            });
    });
}
